<!--
 * @FileDescription: 自定义时间线组件
 * @Author: 朱建波
 * @Date: 2023-10-30
 * @LastEditors: 朱建波 342393950@qq.com
 *
 * @name: ZTimeLine
 *
 * @Props
 * @property {Array} list                  显示数据 [ { type, color } ] type：dot类型 primary success warning danger info    color：dot颜色
 * @property {String} placement            显示内容排列方式 block 换行 line 同行
 * @property {String} line                 左侧线条类型   dashed 虚线 solid 实线
 * @property {Boolean} reverse             节点排序方向，默认为正序
 * @property {Boolean} loading             数据加载效果
 * @property {Boolean} depth               dot颜色深浅
 * @property {String} text                 空数据展示文字
 *
 * @Slots
 * index                                   自定义index内容
 * empty                                   自定义空数据内容
 *
 * @Methods
-->
<script>
export default {
  name: 'ZTimeLine',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    placement: {
      type: String,
      default: 'line'
    },
    line: {
      type: String,
      default: 'dashed'
    },
    reverse: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    depth: {
      type: Boolean,
      default: false
    },
    hide: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: '暂无数据'
    }
  }
}
</script>
<template>
  <div :class="['z-timeline', line, reverse && 'reverse', depth && 'depth', hide && 'hide']" v-loading="loading">
    <div v-if="list.length">
      <div class="z-timeline-item" v-for="(item, index) in list" :key="item.id || index">
        <div class="z-timeline-line"></div>
        <div :class="['z-timeline-dot', item.type]" :style="{backgroundColor: item.color}"></div>
        <div class="z-timeline-content">
          <slot :name="index">
            <div class="date" v-if="item.date">{{ item.date }}</div>
            <div class="content">{{ item.content }}</div>
            <div class="desc" v-if="item.desc">{{ item.desc }}</div>
            <div class="desc" v-if="item.arr">
              <div class="item" v-for="(child, idx) in item.arr" :key="idx">{{ child }}</div>
            </div>
          </slot>
        </div>
      </div>
    </div>
    <template v-else>
      <slot name="empty">
        <div class="z-timeline-empty">
          <img src="@/assets/img/empty.png" :alt="text" />
          <p>{{ text }}</p>
        </div>
      </slot>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.z-timeline {
  &.dashed {
    .z-timeline-line {
      border-style: dashed;
    }
  }
  &.solid{
    .z-timeline-line {
      border-style: solid;
    }
  }
  &.depth {
    .z-timeline-dot {
      background-color: #1C4EFD;
    }
  }
  &.hide {
    .z-timeline-item {
      .z-timeline-line {
        display: none;
      }
      .z-timeline-dot {
        display: none;
      }
    }
  }
  &.reverse {
    .z-timeline-item {
      &:first-child {
        .z-timeline-dot {
          background-color: #1C4EFD;
          &.primary { background-color: #1C4EFD; }
          &.success { background-color: #23C343; }
          &.warning { background-color: #F6AD3C; }
          &.danger { background-color: #F53F3F; }
          &.info { background-color: #909399; }
        }
      }
    }
  }

  &:not(.reverse) {
    .z-timeline-item {
      &:last-child {
        .z-timeline-dot {
          background-color: #1C4EFD;
          &.primary { background-color: #1C4EFD; }
          &.success { background-color: #23C343; }
          &.warning { background-color: #F6AD3C; }
          &.danger { background-color: #F53F3F; }
          &.info { background-color: #909399; }
        }
      }
    }
  }
  &-item {
    position: relative;
    padding-left: 2rem;
    &:not(:last-child) {
      padding-bottom: 20rem;
    }
    &:last-child {
      .z-timeline-line {
        display: none;
      }
    }
  }
  &-line {
    position: absolute;
    left: 4rem;
    top: 6rem;
    height: 100%;
    border-color: #ddd;
    border-width: 0 0 0 1rem;
  }
  &-dot {
    position: absolute;
    top: 4rem;
    left: 0rem;
    width: 10rem;
    height: 10rem;
    background-color: #8da5fa;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    &.primary { background-color: #AAC4FF; }
    &.success { background-color: #aae4b5; }
    &.warning { background-color: #fddcaa; }
    &.danger { background-color: #ffcbcb; }
    &.info { background-color: #e7ecf7; }
  }
  &-content {
    padding-left: 20rem;
    font-size: 14rem;
    line-height: 1.5;
    color: #666;
    .date {
      color: #333;
      + .content {
        padding-top: 10rem
      }
    }
    .desc {
      margin-top: 8rem;
      .item {
        padding: 4rem 0;
      }
    }
  }
  &-empty {
    padding: 20rem 0;
    font-size: 14rem;
    line-height: 30rem;
    color: #aaa;
    text-align: center;
  }
}
</style>
